// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mixability Section Styling */
.mixability-section {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.mixability-section h4 {
  color: #0b2d71;
  border-bottom: 2px solid #0b2d71;
  padding-bottom: 0.5rem;
}

/* Form Styling */
.form-control {
  font-size: 0.9rem;
}

/* Label alignment */
label.col-form-label {
  padding-top: calc(0.375rem + 1px);
}

/* Button styling */
.button.small {
  min-width: 80px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/mixability/mixability.component.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB","sourcesContent":["/* Mixability Section Styling */\n.mixability-section {\n  background-color: #f8f9fa;\n  padding: 2rem;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.mixability-section h4 {\n  color: #0b2d71;\n  border-bottom: 2px solid #0b2d71;\n  padding-bottom: 0.5rem;\n}\n\n/* Form Styling */\n.form-control {\n  font-size: 0.9rem;\n}\n\n/* Label alignment */\nlabel.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n}\n\n/* Button styling */\n.button.small {\n  min-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
